import { ratings } from "@/mocks/ratings";
import SectionHeading from "./SectionHeading";

export default function RatingSection() {
  return (
    <section id="rating" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Rating & scale"
          title="尺度与分级：一个客观的参照系"
          desc="搜索「尺度」与「大尺度」时，最实用的其实是分级制度。它不评价作品好坏，只客观标注内容强度——先看分级，再决定要不要看。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 rounded-lg border border-background-200/70 overflow-hidden">
            {ratings.map((r, i) => (
              <div
                key={r.code}
                className={`flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 p-5 md:p-6 ${
                  i !== ratings.length - 1 ? "border-b border-background-200/70" : ""
                } ${r.code === "NC-17" ? "bg-accent-50" : r.code === "R" ? "bg-primary-50/60" : ""}`}
              >
                <span
                  className={`shrink-0 w-24 h-12 flex items-center justify-center rounded-md font-heading font-bold text-base md:text-lg tracking-wide ${
                    r.code === "NC-17"
                      ? "bg-accent-500 text-background-50"
                      : r.code === "R"
                      ? "bg-primary-500 text-background-50"
                      : "bg-foreground-950 text-background-50"
                  }`}
                >
                  {r.code}
                </span>
                <div className="min-w-0">
                  <div className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {r.name}
                  </div>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700">{r.desc}</p>
                  <p className="mt-1.5 font-label text-xs text-accent-700">{r.note}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg bg-secondary-500 text-background-50 p-6">
              <i className="ri-question-answer-line text-2xl"></i>
              <h3 className="mt-3 font-heading text-lg font-semibold">「尺度」到底指什么</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-50/90">
                它通常指作品对成人议题、身体与情感的呈现开放程度。尺度是客观描述，本身不含褒贬。
              </p>
            </div>
            <div className="rounded-lg bg-background-100 border border-background-200/70 p-6">
              <i className="ri-lightbulb-line text-2xl text-accent-600"></i>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                大尺度 ≠ 低俗
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                关键看呈现是否服务于人物与主题。为叙事必需的克制表达，与为吸引眼球的堆砌，观感天差地别。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}